import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EffectiveMarginTarget } from "models/project-margin-target";

// Cache of the margin bands in effect per fiscal year, shared by the PM screens.
export interface ProjectMarginTargetsSliceState {
    byFiscalYear: Record<number, EffectiveMarginTarget>
    currentFiscalYear: number | null
}

export const initialState: ProjectMarginTargetsSliceState = {
    byFiscalYear: {},
    currentFiscalYear: null,
};

const ProjectMarginTargetsSlice = createSlice({
    name: "project-margin-targets-slice",
    initialState,
    reducers: {
        setEffectiveMarginTarget(state, { payload }: PayloadAction<{ target: EffectiveMarginTarget, isCurrent: boolean }>) {
            state.byFiscalYear[payload.target.fiscalYear] = payload.target;
            if (payload.isCurrent) state.currentFiscalYear = payload.target.fiscalYear;
        },
        // After an admin edit the cached bands are stale
        clearEffectiveMarginTargets(state) {
            state.byFiscalYear = {};
            state.currentFiscalYear = null;
        },
    },
});

export const { setEffectiveMarginTarget, clearEffectiveMarginTargets } = ProjectMarginTargetsSlice.actions;

export default ProjectMarginTargetsSlice.reducer;
